import React, { FC } from 'react';
import { Image } from 'react-native';
import styles from './styles';

export type LogoProps = {
  style?: any;
  logoOnly?: boolean;
};

export const Logo: FC<LogoProps> = (props) => {
  const { logoOnly, style } = props;
  return (
    <>
      {logoOnly && (
        <Image
          source={require('./assets/logo_only.png')}
          style={[styles.imageOnly, style]}
        />
      )}
      {!logoOnly && (
        <Image
          source={require('./assets/logo.png')}
          style={[styles.image, style]}
        />
      )}
    </>
  );
};

export default Logo;
